/* app/js/src/components/clipping-studio/panels/destination-tab/instagram-publish-settings/clipping-studio-instagram-publish-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.instagram-settings {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.instagram-settings__label {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.instagram-settings__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.instagram-settings__field--row {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.instagram-settings__dropdown {
  width: 100%;
}
.instagram-settings__checkbox {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
  --mdc-checkbox-selected-checkmark-color: rgb(255, 255, 255);
  --mdc-checkbox-selected-focus-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-hover-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-pressed-icon-color: rgb(45, 187, 252);
}
.instagram-settings__checkbox ::ng-deep .mdc-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
}
.instagram-settings__checkbox ::ng-deep .mdc-checkbox__ripple,
.instagram-settings__checkbox ::ng-deep .mat-mdc-checkbox-ripple,
.instagram-settings__checkbox ::ng-deep .mat-mdc-focus-indicator {
  display: none;
}
.instagram-settings__checkbox.mat-mdc-checkbox-disabled {
  cursor: not-allowed;
}
.instagram-settings__checkbox.mat-mdc-checkbox-disabled ::ng-deep .mdc-label {
  color: rgba(0, 0, 0, 0.35);
}
.instagram-settings__checkbox.mat-mdc-checkbox-disabled ::ng-deep .mdc-checkbox__background {
  border-color: rgb(194, 204, 219) !important;
  background-color: rgb(235, 240, 244) !important;
}
.instagram-settings__field-help {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  flex: 0 0 1rem;
  border: 1px solid rgba(0, 0, 0, 0.54);
  border-radius: 50%;
  color: rgba(0, 0, 0, 0.54);
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  outline: none;
}
.instagram-settings__field-help:hover .instagram-settings__field-tooltip,
.instagram-settings__field-help:focus .instagram-settings__field-tooltip {
  opacity: 1;
  visibility: visible;
}
.instagram-settings__field-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 0.5rem);
  z-index: 10;
  width: max-content;
  max-width: 220px;
  padding: 6px 8px;
  border-radius: 4px;
  background: rgba(33, 33, 33, 0.95);
  color: rgb(255, 255, 255);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
/*# sourceMappingURL=clipping-studio-instagram-publish-settings.component.css.map */
